// ============================================================================
// pollGuestLinks.ts — ССЫЛКИ ПРОХОЖДЕНИЯ ТЕСТА для кабинета пациента.
//
// Ссылка строится на ВНЕШНЕМ адресе базы (publicBaseUrl: base_url публикации →
// внешний URL платформы/origin), а НЕ на window.location.origin: на desktop
// origin = wails.localhost и переданная пациенту ссылка не открылась бы.
// Слаг базы подставляет psyWorkspace.pollLink — единая точка формата
// `/poll/{база}/{токен}` (та же, что у публичной страницы прохождения).
//
// Открытие — в новой вкладке; блокировка всплывающих окон даёт явный переход
// в текущем окне (без тихого «ничего не произошло»).
// ============================================================================

import { publicBaseUrl } from '@/lib/publicBaseUrl';
import { pollCodeEntry, pollLink } from '@/lib/psyWorkspace';

function openExternalUrl(url: string): void {
  if (!url) throw new Error('Не удалось построить ссылку прохождения теста');
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) window.location.assign(url);
}

/** Открыть страницу прохождения по токену назначения. */
export async function openPollLink(token: string): Promise<void> {
  const base = await publicBaseUrl();
  openExternalUrl(pollLink(base, token));
}

/** Открыть страницу ввода короткого кода (без токена). */
export async function openPollCodeEntry(): Promise<void> {
  const base = await publicBaseUrl();
  openExternalUrl(pollCodeEntry(base));
}
